@let controls = form.controls;
@if (variant() === 'route') {
  <h6 class="span">{{ `${I18N}.heading` | translate }}</h6>
}

<ng-container
  *ngTemplateOutlet="
    groupTemplate;
    context: { label: 'labels.arrival', controls: controls.arrival.controls }
  "
></ng-container>

<div class="placeholder"></div>

<ng-container
  *ngTemplateOutlet="
    groupTemplate;
    context: { label: `${I18N}.start`, controls: controls.start.controls }
  "
></ng-container>

<ng-container
  *ngTemplateOutlet="
    groupTemplate;
    context: { label: `${I18N}.end`, controls: controls.complete.controls }
  "
></ng-container>

@if (variant() === 'route') {
  <div class="buttons span">
    <onyx-button variant="outlined" color="red" (click)="cancel()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="save()">
      {{ 'labels.save' | translate }}
    </onyx-button>
  </div>
}

<ng-template let-label="label" let-controls="controls" #groupTemplate>
  <onyx-form-group
    [label]="label"
    [controls]="[controls.date, controls.time]"
    [gap]="8"
  >
    @let isModal = variant() === 'modal';
    <onyx-form-group [width]="context === 'map' ? '70%' : '60%'">
      <onyx-datepicker
        [formControl]="controls.date"
        [size]="isModal ? 32 : 40"
        [showErrors]="false"
      ></onyx-datepicker>

      <onyx-suggestions
        [control]="controls.date"
        [suggestions]="DATE_SUGGESTIONS"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-form-group [width]="context === 'map' ? '30%' : '40%'">
      <onyx-timepicker
        [formControl]="controls.time"
        [size]="isModal ? 32 : 40"
        [showErrors]="false"
      ></onyx-timepicker>

      <onyx-suggestions
        [control]="controls.time"
        [suggestions]="TIME_SUGGESTIONS"
        (selectedSuggestionChange)="controls.date.setValue(TODAY)"
      ></onyx-suggestions>
    </onyx-form-group>
  </onyx-form-group>
</ng-template>
